<adm-type-ahead-selector2
  [label]="label()"
  [required]="required()"
  [validationControl]="validationControl()"
  [requiredErrorText]="requiredErrorText()"
  [itemTemplate]="pricePolicyDropdownItemTemplate"
  [fetchFn]="fetchPricePoliciesForFilters()"
  [fetchByIdFn]="fetchPricePolicyById"
  [initialId]="initialPricePolicyId() ?? undefined"
  (itemSelected)="pricePolicySelected($event)"
  identityPropertyName="id"
  [disabled]="disabled()"
  [resetTrigger]="resetTrigger()"
  [suffixIcon]="suffixIcon()"
  [suffixIconTooltip]="suffixIconTooltip()">
</adm-type-ahead-selector2>
<ng-template #pricePolicyDropdownItemTemplate let-pricePolicy>
  <div class="typeahead-item tiny-text">
    <strong class="icon-with-text">
      {{ pricePolicy.name }}
    </strong>
    <span>
      @if (pricePolicy.consumerPriceInKrWithVat?.fixed) {
        Fast
        @if (!pricePolicy.organizationId) {
          &middot; Global
        } @else {
          &middot; Organisation
        }
        &middot; Forbrugerpris:
        {{ pricePolicy.consumerPriceInKrWithVat.fixed.value | dkCurrency }}
      } @else if (pricePolicy.consumerPriceInKrWithVat?.dynamic) {
        Dynamisk
        @if (!pricePolicy.organizationId) {
          &middot; Global
        } @else {
          &middot; Organisation
        }
        &middot; Forbrugerpris: {{ pricePolicy.consumerPriceInKrWithVat.dynamic.low | dkCurrency }} -
        {{ pricePolicy.consumerPriceInKrWithVat.dynamic.high | dkCurrency }}
      }
    </span>
  </div>
</ng-template>
